import {
  createAggregationCountFilter,
  createAssetMetaOrTagGroupBy,
  createDetachedResponseProfile,
  createDynamicOrderBy,
  createOnDemandResponseProfile,
} from '../../factories';
import { KalturaChannelFilter } from '../../filters';

export const orderByMapping: Record<string, KalturaChannelFilter['orderBy']> = {
  name: 'NAME_ASC',
  RELEVANCY_DESC: 'RELEVANCY_DESC',
  NAME_ASC: 'NAME_ASC',
  NAME_DESC: 'NAME_DESC',
  VIEWS_DESC: 'VIEWS_DESC',
  RATINGS_DESC: 'RATINGS_DESC',
  VOTES_DESC: 'VOTES_DESC',
  START_DATE_DESC: 'START_DATE_DESC',
  START_DATE_ASC: 'START_DATE_ASC',
  LIKES_DESC: 'LIKES_DESC',
  CREATE_DATE_ASC: 'CREATE_DATE_ASC',
  CREATE_DATE_DESC: 'CREATE_DATE_DESC',
};

export function getDynamicOrderBy(orderBy?: string) {
  if (!orderBy) {
    return undefined;
  }

  const assetOrderBy = orderByMapping[orderBy];

  if (!assetOrderBy) {
    return createDynamicOrderBy({
      name: orderBy,
      orderBy: 'META_ASC',
    });
  }
}

export function getGroupBy(groupBy?: string) {
  if (groupBy) {
    return [createAssetMetaOrTagGroupBy({ value: groupBy })];
  }
}

export function getRetrievedProperties({
  availableRatings,
  availableProviders,
  retrievedProperties,
}: {
  availableRatings: string[];
  availableProviders: string[];
  retrievedProperties?: string;
}) {
  // rating's name is dynamic so need to compose metas dynamically with avail ratings from dms,
  const metasProperties = [...availableRatings, ...availableProviders].map((r) => `metas.${r}`).join(',');
  return `${retrievedProperties},${metasProperties}`;
}

export function getResponseProfile({
  availableRatings,
  availableProviders,
  retrievedProperties,
  groupBy,
}: {
  availableRatings: string[];
  availableProviders: string[];
  retrievedProperties?: string;
  groupBy?: string;
}) {
  const retrievedPropertiesWithRatings = getRetrievedProperties({
    availableRatings,
    availableProviders,
    retrievedProperties,
  });

  if (groupBy) {
    return createOnDemandResponseProfile({
      ...(retrievedProperties && { retrievedProperties: retrievedPropertiesWithRatings }),
      relatedProfiles: [
        createDetachedResponseProfile({
          name: 'group_result',
          filter: createAggregationCountFilter({}),
        }),
      ],
    });
  }

  if (retrievedProperties) {
    return createOnDemandResponseProfile({
      retrievedProperties: retrievedPropertiesWithRatings,
    });
  }
}

export function getOrderBy(orderBy: string | undefined) {
  return orderBy ? orderByMapping[orderBy] : undefined;
}
